"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _universalCookie = _interopRequireDefault(require("universal-cookie"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = _universalCookie["default"];
exports["default"] = _default;
module.exports = exports.default;